import { Box, Skeleton } from '@mui/material';

import Stack from './Stack';

export const SearchNotEnteredSkelton = () => {
  return (
    <Stack alignCenter space={3} sx={{ maxHeight: '112px' }}>
      <Skeleton
        variant="rounded"
        width={112}
        height={112}
        sx={{ minWidth: 112, borderRadius: 2 }}
      />
      <Stack column space={1.5} sx={{ width: '100%' }}>
        <Skeleton
          variant="rounded"
          sx={{
            width: '54px',
            height: '24px',
            borderRadius: '20px',
          }}
        />
        <Box>
          <Skeleton variant="text" sx={{ fontSize: '18px' }} />
          <Skeleton variant="text" sx={{ width: '60%', fontSize: '18px' }} />
        </Box>
        <Skeleton variant="text" sx={{ width: '40px', fontSize: '12px' }} />
      </Stack>
      <Skeleton
        variant="circular"
        width={32}
        height={32}
        sx={{ minWidth: '32px' }}
      />
    </Stack>
  );
};
